import React, { memo } from 'react';
import styles from './userContentAvatar.module.scss';
import sideBarStyles from '../SideBar/sideBar.module.scss';
import Avatar from '../../../shared/components/Avatar';
import { useTranslation } from 'react-i18next';

const UserContentAvatar = ({ loggedUser = {} }) => {
    const { t } = useTranslation('home');

    return (
        <div className={`${sideBarStyles.itemsContent} ${styles.itemContent}`}>
            <div className={`${sideBarStyles.item}`}>
                <div className={`${sideBarStyles.icon} ${sideBarStyles.min}`}>
                    <Avatar name={loggedUser.name} lastname={loggedUser.lastName} email={loggedUser.email} />
                </div>
                <div className={`${styles.info} ${sideBarStyles.title}`}>
                    <span className={styles.title}>{`${loggedUser.name} ${loggedUser.lastName}`}</span>
                    {loggedUser.profile && loggedUser.profile.length > 0 && (
                        <span className={styles.subTitle}>
                            {' '}
                            {loggedUser.profile.map(profile => {
                                // Si profile es un objeto con propiedad 'name', usar esa propiedad
                                // Si es un string, usarlo directamente
                                const profileName = typeof profile === 'object' ? (profile.name || profile.code || '') : profile;
                                return typeof profileName === 'string' ? t(profileName.toLowerCase()) : '';
                            }).join(', ')}{' '}
                        </span>
                    )}
                </div>
            </div>
        </div>
    );
};

export default memo(UserContentAvatar);
